import { render, staticRenderFns } from "./SpellcastingPanel.vue?vue&type=template&id=5e3ae72c"
import script from "./SpellcastingPanel.vue?vue&type=script&lang=js"
export * from "./SpellcastingPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports